module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-photo-hair-make-eb29fe35c274ec937f18ba30828bf825.jpg";